import { MessageService } from "../message_service";
import RouteCtrl from '../../routes/Routes'

export default async function GetCasesPriorities() {
    let messageService = new MessageService()
    const response = await fetch(RouteCtrl.getCasesPriorities, {
        method: "GET"
    }).catch(err => messageService.printToast("Generics", "error", 9))
    return response.json()
}